import React, { useEffect, useState } from 'react';
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,

    Box,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverHeader,
    PopoverBody,
} from '@chakra-ui/react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";

import SpinnerLoader from 'components/Spinner/SpinnerLoader';
import { useToasts } from 'react-toast-notifications';
import { fetchAsyncGetNewCreditNumber } from 'redux/creditSlice';
import { useDispatch } from 'react-redux';
import { poNumberFormate } from 'jsFunctions/helperFunctions';
import { fetchAsyncGetAllCreditByExpenseId } from 'redux/creditSlice';
import { fetchAsyncCreateNewCredit } from 'redux/creditSlice';
import CreditColumnTable from 'views/admin/embrillTable/creditColumnTable';

import dateTimeFormat from 'jsFunctions/dateTimeFormat';
import { currencyFormate } from 'jsFunctions/helperFunctions';

import { creditAmountValidate } from 'validation/creditAmount';
import { BsFillFileEarmarkPdfFill, BsInfoCircle } from 'react-icons/bs';
import { fetchAsyncFilePreviewData } from 'redux/userSlice';
import { fetchAsyncCreateNewSalesCredit } from 'redux/creditSlice';


const RemarksPopover = ({remarks})=>{
  return (

    <Popover className="credit-popover" trigger='hover'  placement="right-end" >
      <PopoverTrigger>
        <BsInfoCircle size={14} className='mx-3' style={{ cursor: "pointer", color: 'blue' }} />
      </PopoverTrigger>
      <PopoverContent width={400}>
        <PopoverArrow />
        <PopoverHeader>Credit Remarks</PopoverHeader>
        <PopoverBody>
          {remarks}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  
  )
}
const CreditForm = (
    {
        closeModal,
        isOpen,
        editData,
        remainingAmount,
        vendorId,
        clientId,
        expenseType,
        moduleInfo

    }) => {

    const { addToast } = useToasts();
    const dispatch = useDispatch();
    const [creditAmountError,setCreditAmountError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [creditNumber,setCreditNumber] = useState("")
    const [selectedFile, setSelectedFile] = useState("")
    const [paymentAmount, setPaymentAmount] = useState(remainingAmount);
    const  [selectedDate, setSelectedDate] = useState("")
    const [allCredit,setAllCredit] = useState([])
    const [tableData, setTableData] = useState([])
    const [remarks,setRemarks] = useState("")
    const [errors,setErrors] = useState({})
    const handleFileChange = (e) => {
        if (e.target.files) {
          if (e.target.files[0].size < 2 * 1024 * 1024) {
            setSelectedFile(e.target.files[0]);
          } else {
            addToast("Please attach file less then 2Mb", { appearance: "warning" });
          }
        }
    };

    const generateNewCreditNumber = async()=>{
        const data = {
            poNo:editData?.poNo
        }
        await dispatch(fetchAsyncGetNewCreditNumber(data)).then((res)=>{
      
          if(res?.payload){
            const crNo = res?.payload?.crNo;
            const formatedCrNum = poNumberFormate(crNo)
            setCreditNumber(formatedCrNum)
          }
          }).catch((err)=>{
            addToast(`Error while fetching credit number!`,{ appearance: "error" });
      
          })
    }

    const getAllCreditByExpenseID = async()=>{
        await dispatch(fetchAsyncGetAllCreditByExpenseId(editData?._id)).then((res)=>{
            if(res?.payload){
            const creditData = res.payload.allCredit;
            if(creditData){
                setAllCredit(creditData)
            }
            }
            }).catch((err)=>{
              addToast(`Error while fetching credit number!`,{ appearance: "error" });
            })
    }


    useEffect(()=>{
        generateNewCreditNumber();
        getAllCreditByExpenseID();
    },[])

   
    const createFormData = () => {
      const formData = new FormData();
      formData.append("poNo", JSON.stringify(editData.poNo));
      formData.append("crNo", creditNumber);
      formData.append("expenseId", editData?._id);
      formData.append("vendorId", vendorId?.value || "");
      formData.append("clientId", clientId?.value || "");
      formData.append("expenseType", expenseType);
      formData.append("amount", paymentAmount);
      formData.append("date", selectedDate);
      formData.append("file", selectedFile);
      formData.append("remarks", remarks);
      return formData;
  };
  const handleSuccess = async () => {
      await getAllCreditByExpenseID();
      generateNewCreditNumber();
      resetForm();
      addToast('credit created successfully');
      setIsLoading(false);
  };
  const handleError = (message) => {
      setIsLoading(false);
      addToast(message, { appearance: "error" });
  };
  const resetForm = () => {
      setPaymentAmount("");
      setSelectedDate("");
      setSelectedFile("");
  };

    const handleAddCredit = async (e) => {
      e.preventDefault();
      const data = {
        amt: paymentAmount,
        pmtDt: selectedDate,
      };
      const multipleAddPaymentInfo = [...allCredit, data];
      const creditError = creditAmountValidate(
        multipleAddPaymentInfo,
        data,
        remainingAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditAmountError(creditError);
        return;
      } else {
        setCreditAmountError({});
      }

      const formData = createFormData();

      try {
        setIsLoading(true);
        const action =
          vendorId && vendorId?.value
            ? fetchAsyncCreateNewCredit
            : fetchAsyncCreateNewSalesCredit;
        const res = await dispatch(
          action({ moduleId: moduleInfo?._id, formData })
        );
        if (res?.payload) {
          await handleSuccess();
        } else {
          handleError("credit not created");
        }
      } catch (error) {
        handleError("Error while fetching add new credit!!");
      }
    };

    const handleFilePreview = async (key, spId) => {
      setIsLoading(true)

      try {
        const data = { key:key, spId:spId };
        const response = await dispatch(fetchAsyncFilePreviewData(data)).unwrap();
        const contentType = response.headers['Content-Type'] || response.headers['content-type']; 
        
        const blob = new Blob([response.data], { type: contentType });
        const pdfUrl = window.URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank'); 
        setIsLoading(false)

      } catch (error) {
        setIsLoading(false)

        addToast(`Error fetching PDF preview: ${error.message}`, { appearance: "error" });
      }
    };

    const columnData = [
      {
        Header: "Credit No",
        accessor: "crNo",
      },
      {
        Header: "Credit Date",
        accessor: "creditDate",
      },
      {
        Header: "Remarks",
        accessor: "remarks",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "File",
        accessor: "file",
      },
    ];

      useEffect(() => {
        if (allCredit && allCredit.length > 0) {
          const content = allCredit.map((data, index) => {

            return {
              no: index + 1,
              crNo: (
                <span 
                  style={{ cursor: "pointer",color:'blue'}}
                >
                  {data.crNo && poNumberFormate(data.crNo)}
                </span>
              ),
              amount:(
                <span>
                  {data?.amt ? currencyFormate(data?.amt ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
                </span>
              ),
              creditDate:dateTimeFormat(data?.pmtDt),
              spId:data?.fils?.spId || "",
              file: data?.fils?.key ? (
                <BsFillFileEarmarkPdfFill
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleFilePreview(data?.fils?.key,data?.fils?.spId);

                  }}
                />
              ) : (
                <BsFillFileEarmarkPdfFill
                  style={{ cursor: "not-allowed" }}
                  color="gray"
                />
              ),
              remarks:data?.rmks ?
              <Box display="flex" alignItems="self-start">

                <RemarksPopover remarks={data?.rmks}/>
              </Box>
              :
              <BsInfoCircle size={14} className='mx-3' style={{ cursor: "not-allowed" }}
              color="gray" />
             
            };
          });
          setTableData(content);
        } else {
          setTableData([]);
        }
        const useCreditAmt = allCredit.reduce((total = 0, itm) => total + itm.amt, 0);
        const remaining = parseFloat(remainingAmount || 0) - parseFloat(useCreditAmt || 0);
        setPaymentAmount(remaining);
      }, [allCredit]);

     

      const handleRemarksChange = (e)=>{
        const value = e?.target?.value;
        const encoder = new TextEncoder(); 
        const byteLength = encoder.encode(value).length;
        if(byteLength <=256){
          setRemarks(value)
          setErrors({
            ...errors,
            remarks:''
          })
        }
        else{
          setErrors({
            ...errors,
            remarks:'Remarks must be within the 256 byte limit!'
          })
        }
      }
    return (
      <>
        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          className="modal-main"
          size="xl"
        >
          <ModalOverlay />
          <ModalContent
            className="info-model"
            top="0" // Position it at the top
            margin="0 auto" // Center it horizontally
            bottom="0"
          >
            <ModalHeader className="expense-modal-header">
              Add Credit
            </ModalHeader>
            <ModalCloseButton className="expense-modal-header" />
            {isLoading ? (
              <SpinnerLoader />
            ) : (
              <ModalBody>
                <Form>
                  <div className="form-card">
                    <Row className="">
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Credit Number <span className="span-star">*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="poNo"
                            value={creditNumber}
                            disabled
                          />
                        </Box>
                      </Col>

                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Credit Amount <span className="span-star">*</span>
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <span className="rupee-symbol">₹</span>{" "}
                            </InputGroup.Text>
                            <CurrencyFormat
                              customInput={Form.Control}
                              type="text"
                              defaultValue={paymentAmount}
                              value={paymentAmount || ""}
                              onValueChange={(e) => {
                                setPaymentAmount(e.value);
                              }}
                              thousandSeparator={true}
                              // prefix={"$"}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </InputGroup>
                        </Box>
                        <p className="form_error">
                          {" "}
                          {creditAmountError?.amount}
                        </p>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Credit Date <span className="span-star">*</span>
                          </Form.Label>

                          <Box>
                            <DatePicker
                              name="paymentdate"
                              className="monthDate"
                              dateFormat="dd-MMM-yyyy"
                              selected={selectedDate}
                              onChange={(date) => {
                                setSelectedDate(date);
                              }}
                              onFocus={() => {
                                if (!selectedDate) {
                                  const defaultDate = new Date();
                                  setSelectedDate(defaultDate);
                                }
                              }}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                            />
                          </Box>
                        </Box>
                        <p className="form_error">
                          {" "}
                          {creditAmountError?.paymentDate}
                        </p>
                      </Col>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Upload File (img/pdf)</Form.Label>

                          <Form.Control
                            type="file"
                            name="creditfile"
                            className=""
                            placeholder="PDF"
                            onChange={(e) => handleFileChange(e)}
                            accept="image/pdf"
                          />
                        </Box>
                      </Col>
                    </Row>
                    <Row className='mt-3'>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Remarks </Form.Label>

                          <Form.Control
                            as="textarea" 
                            rows={2}
                            name="remarks"
                            placeholder="Type Here..."
                            value={remarks}
                            onChange={(e) => handleRemarksChange(e)}
                            isInvalid={!!errors?.remarks}
                          />
                        </Box>
                      </Col>
                      <p className="form_error">{errors?.remarks}</p>
                    </Row>

                    <Box
                      className="mt-4"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Button
                        className="add-quotation-btn"
                        onClick={(e) => handleAddCredit(e)}
                        colorScheme="green"
                      >
                        Add
                      </Button>
                    </Box>
                  </div>
                </Form>

                <CreditColumnTable
                  columnsData={columnData}
                  tableData={tableData}
                  type={""}
                />
              </ModalBody>
            )}
            <ModalFooter>
              <Button onClick={closeModal}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
};

export default CreditForm;
